import { Injectable } from '@angular/core';
import { Route } from '@angular/router';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { Utils } from 'src/app/_helpers';

@Injectable({
    providedIn: 'root'
})
export class WebViewGuard  {

    constructor(private _router: Router) { }

    /**
     * Checks the access by checking if user is opening this from flutter in app webview.
     * @param route - The route to check access for.
     * @returns An Observable<boolean> or Promise<boolean> or boolean indicating whether the access is allowed.
     */
    checkAccess(route: Route): Observable<boolean> | Promise<boolean> | boolean {
        if((window as any).flutter_inappwebview){
          return true;
        }
        this._router.navigate(['dashboard']);
        return false;
    }

    canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
        return this.checkAccess(route);
    }

    canActivate(route: Route): Observable<boolean> | Promise<boolean> | boolean {
        return this.checkAccess(route);
    }
}
